module.exports = __webpack_public_path__ + "static/media/notice.d094b97.mp3";